import React, { Component } from 'react';
import 'whatwg-fetch';
class getTimer extends Component {

//componentDidMount
 componentWillUnmount () {
   clearInterval(this.timer)
 }


 tick () {
   const url= this.props.dir_url + "webapp/getListPedidoPendientes";
   const token =  this.props.token
   const token_Client = this.props.token_Client

   //console.log(lat+" "+lon)
   //var data = {username: 'example'};
   var obj = { accion:'findpendiente', token, token_Client};
   fetch(url, {
     method: 'POST',
     body: JSON.stringify(obj),
     headers:{
       'Accept':'application/json',
       'Content-Type': 'application/json'
     }
   })
   .then(res => res.json())
   .then((data) => {
     if(data[0].status==="ok"){
       this.props.get_token_pedido(data[0].msg[0].uuid_pedido,data[0].msg[0].estado_pedido,data[0].msg[0].tiempo,data[0].msg[0].id_estado_pedido,data[0].msg[0].detalle)
     }else{
       this.props.get_token_pedido("","","","","")
     }
     //console.log(data)
   })
   .catch(console.log)
 }
 startTimer () {
   clearInterval(this.timer)
   this.timer = setInterval(this.tick.bind(this), 5000)
 }
 stopTimer () {
   clearInterval(this.timer)
 }
 render () {
   const id_estado_pedido = this.props.id_estado_pedido
   let modal = <React.Fragment>
                <div className="cssversion_pw100 cssversion_ph100">
                  <div className="cssversion_pw100 cssversion_contentCenter" style={{"display":"flex"}}>
                    <img style={{"height":"70px"}} alt="Cargando Imagen . . ." src={ require('../image/flecha_arriba.gif') }  />
                  </div>
                  <div className="cssversion_pw100 cssversion_contentCenter" style={{"display":"flex"}}>
                    <span className="span-global">Seleccione un Local</span>
                  </div>
                </div>
               </React.Fragment>

   if(Number(id_estado_pedido)!==0){
     const estado_pedido = this.props.estado_pedido
     let tiempo_estimado= this.props.tiempo_estimado
     let image
     if(Number(tiempo_estimado)<0){
       tiempo_estimado=0
     }
     //let color = "white"
     let backgroundColor ="white"
     //default-case:
     switch(Number(id_estado_pedido)) {
       default:
        break
       case 6:
         image = <React.Fragment>
                <img style={{"height":"70px"}} alt="Cargando Imagen . . ." src={ require('../componentes_generales/loading-alert.gif') }  />
                </React.Fragment>
          //color = "black"
         break
       case 1:
          image = <React.Fragment>
                 <img style={{"height":"70px"}} alt="Cargando Imagen . . ." src={ require('../componentes_generales/preparando.gif') }  />
                 </React.Fragment>
          backgroundColor = "#f3b35c"
          break
       case 2:
          image = <React.Fragment>
                <img style={{"height":"70px"}} alt="Cargando Imagen . . ." src={ require('../componentes_generales/entregando_motorizado.gif') }  />
                </React.Fragment>
          //color = "black"
          break

     }


     modal =
     <React.Fragment>
     <div onClick={ () => this.props.get_go_to_sub("editdatospedido")} style={{"backgroundColor":backgroundColor,"borderRadius": "30px 30px 0px 0px","height":"100%","width":"100%"}}>
       <div className="cssversion_pw100 cssversion_ph100" >
        <div className="cssversion_pw100 cssversion_pxh70 cssversion_contentCenter">
           {image}
         </div>
         <div className="cssversion_pw100 cssversion_pxh50 cssversion_contentCenter">
           <span className="span-global-link" >{estado_pedido} - {tiempo_estimado} Minutos</span>
         </div>
       </div>
      </div>
     </React.Fragment>
   }
   return (
     <React.Fragment>
     {modal}
     </React.Fragment>
   )
 }
 componentDidMount (){

   this.startTimer();
 }
}
export default getTimer;
